/// <reference path="../../public/jquery-1.6.2.min.js" />
/// <reference path="../../public/General.js" />
/// <reference path="../../SumoDataAccess.js" />
/// <reference path="../../SumoClass.js" />
/// <reference path="../ControlBase.js" />

if (isNullOrUndefined(sumo)) {
    throw ('Dropdown.js requies the sumo namespace defined in SumoClass.js');
}

if (isNullOrUndefined(sumo.controls)) {
    throw ('Dropdown.js requies the sumo.controls namespace defined in ControlBase.js');
}

// options
//  title
//  viewportType - inline, float
//  contentType - html, jQueryElement, domElement
//  content
//  cssClass
/**
 * @constructor
 * @param  {} aId
 * @param  {} aParentId
 * @param  {} aOptions
 * 
 * @example
 * mEventsControls.NotesDropdown = new sumo.controls.Dropdown('EventNotesButton', 'uEventsNotesHeaderHolder', {
        'title': localizeWrapper('cEventViewNotes'),
        'viewportType': 'inline',
        'contentType': 'jQueryElement',
        'isOpen': false,
        'cssClass': 'EventNotes',
        'content': $('#uEventsNotesHolder')
    });
 */
sumo.controls.Dropdown = function (aId, aParentId, aOptions) {
    "use strict";

    sumo.controls.Dropdown.prototype.baseClass.call(this,
        aId,
        aParentId,
        '<div class="sumo-dropdown-control" id="##id##"></div>',
        aOptions);

    var mThis = this,
        mTitle = '',
        mViewportType = 'inline',
        mContentType = 'undefined',
        mContent = '',
        mCssClass = null,
        mViewportIsVisible = true,
        mViewPort = null,
        mArrow = null,
        mHeader = null,
        mSlideIntoView = true;

    if (!this.isNothing(aOptions)) {
        if (!this.isNothing(aOptions.title)) {
            mTitle = aOptions.title;
        }
        if (!this.isNothing(aOptions.isOpen)) {
            mViewportIsVisible = aOptions.isOpen;
        }
        if (!this.isNothing(aOptions.viewportType)) {
            mViewportType = aOptions.viewportType;
        }
        if (!this.isNothing(aOptions.contentType)) {
            mContentType = aOptions.contentType;
        }
        if (!this.isNothing(aOptions.content)) {
            mContent = aOptions.content;
        }
        if (!this.isNothing(aOptions.cssClass)) {
            mCssClass = aOptions.cssClass;
        }
        if (!this.isNothing(aOptions.mSlideIntoView)) {
            mSlideIntoView = aOptions.mSlideIntoView
        }
    }

    function toggleArrow(aDirection) {
        if (aDirection === 'right') {
            mArrow.removeClass('sumo-dropdown-viewport-arrow-down')
                  .addClass('sumo-dropdown-viewport-arrow-right');
        } else {
            mArrow.removeClass('sumo-dropdown-viewport-arrow-right')
                  .addClass('sumo-dropdown-viewport-arrow-down');
        }
    }

    this.setContent = function (aContent) {
        mContent = aContent;
        switch (mContentType) {
            case 'jQueryElement':
                aContent.appendTo(mViewPort);
                break;
            case 'domElement':
                $(aContent).appendTo(mViewPort);
                break;
            case 'html':
                $(aContent).appendTo(mViewPort);
                break;
        }
    };

    this.hide = function () {        
        mViewportIsVisible = false;
        toggleArrow('right');
        mViewPort.slideUp('fast');
        mThis.trigger('closed', null);
    };

    function mViewPort_OnSlidDown() {
        if (mThis.ControlElement.length > 0) {
            if (!isNullOrUndefined(mThis.mSlideIntoView)) {
                if (mThis.mSlideIntoView) {
                    mThis.ControlElement[0].scrollIntoView(true);
                }//end of if
            }//end of if           
        }//end of if
    }

    this.show = function () {        
        mViewportIsVisible = true;
        toggleArrow('down');
        mViewPort.slideDown('fast', mViewPort_OnSlidDown);
        mThis.trigger('opened', null);
    };

    this.toggleExpander = function () {        
        if (mViewportIsVisible) {
            this.hide();
        } else {
            this.show();
        }
    };

    function header_OnClick(aEvent) {
        aEvent.stopImmediatePropagation();
        mThis.toggleExpander();
    }

    //    function resizeViewPort() {
    //        if (mViewPort !== null) {
    //            mViewPort.height(mThis.ControlElement.innerHeight() - mHeader.height());
    //        }
    //    }

    //    function window_OnResize(e) {
    //        resizeViewPort();
    //    }

    this.dispose = function () {
        //$(window).unbind('resize', window_OnResize);
        mHeader.unbind('click', header_OnClick);

        mThis = null;
        mViewPort = null;
        mArrow = null;
        mHeader = null;

        sumo.controls.Dropdown.prototype.dispose.call(this);
    };

    this.render = function () {
        var lHtml = [];

        lHtml.push('<div class="sumo-dropdown-control-header" id="');
        lHtml.push(this.Id.toString());
        lHtml.push('Header">');
        lHtml.push(mTitle);
        lHtml.push('<div class="sumo-dropdown-viewport-arrow ');
        if (mViewportIsVisible) {
            lHtml.push('sumo-dropdown-viewport-arrow-down');
        } else {
            lHtml.push('sumo-dropdown-viewport-arrow-right');
        }
        lHtml.push('" id="');
        lHtml.push(this.Id.toString());
        lHtml.push('Arrow"></div>');
        lHtml.push('</div>');
        lHtml.push('<div class="sumo-dropdown-control-viewport ');
        if (mViewportType === 'inline') {
            lHtml.push('sumo-dropdown-control-viewport-inline');
        } else if (mViewportType === 'float') {
            lHtml.push('sumo-dropdown-control-viewport-float');
        }
        lHtml.push('" id="');
        lHtml.push(this.Id.toString());
        lHtml.push('ViewPort" ');
        if (!mViewportIsVisible) {
            lHtml.push(' style="display:none" ');
        }
        lHtml.push('>');
        if (mContentType === 'html') {
            lHtml.push(mContent);
        }
        lHtml.push('</div>');

        if (!this.isNothing(mCssClass)) {
            this.ControlElement.addClass(mCssClass);
        }
        
        this.ControlElement.html(lHtml.join(''));
        
        mViewPort = this.ControlElement.find('#' + this.Id + 'ViewPort');
        mHeader = this.ControlElement.find('#' + this.Id + 'Header');
        mArrow = this.ControlElement.find('#' + this.Id + 'Arrow');

        if (mContentType === 'jQueryElement') {
            mContent.appendTo(mViewPort);
        } else if (mContentType === 'domElement') {
            $(mContent).appendTo(mViewPort);
        }
        
        mHeader.click(header_OnClick);
        //$(window).resize(window_OnResize);
        veritracks.localization.localize('#' + this.Id);
        this.trigger('render');
    };

    this.render();
};
sumo.controls.Dropdown.prototype = new sumo.controls.ControlBase();
sumo.controls.Dropdown.prototype.constructor = sumo.controls.Dropdown;
sumo.controls.Dropdown.prototype.baseClass = sumo.controls.ControlBase;